<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>{{ modNev || 'Kezdőlap' }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="valaszto-tartalom">
  <div class="valaszto-lap">

    <!-- Köszöntés: ki vagyok, melyik alrendszerben, melyik intézménynél -->
    <header class="valaszto-fejlec">
      <h1>{{ koszones }}{{ nev ? ', ' + nev : '' }}!</h1>
      <p>
        <b>{{ modNev || 'Cronomit' }}</b>
        <span *ngIf="intezmeny"> · {{ intezmeny }}</span>
      </p>
    </header>

    <!-- Főmenü csempékben: ugyanaz a lista, amit a bal menü mutat -->
    <div class="valaszto-racs" *ngIf="csempek.length">
      <button type="button" class="valaszto-csempe" *ngFor="let cs of csempek" (click)="nyit(cs)">
        <ion-icon [name]="cs.icon || 'ellipse-outline'"></ion-icon>
        <span class="valaszto-csempe__cim">{{ cs.title }}</span>
        <span class="valaszto-csempe__almenu" *ngIf="cs.submenu?.length">
          {{ cs.submenu.length }} aloldal
        </span>
      </button>
    </div>

    <!-- A FEJLESZTŐI BELÉPŐ KIKERÜLT.
         Itt a fitness fejlesztői konzoljához (`/devcenter`) vezetett egy csempe.
         A konzol a különvált programmal együtt költözött, tehát ez az alkalmazás
         nem tudja megnyitni – a `fejlesztoi` mezőt a komponens már nem is töltötte
         fel, a szakasz tehát sosem jelent meg. Egy soha meg nem jelenő gomb
         karbantartási teher, nem tartalék. -->

    <!-- Üres állapot: nem takargatjuk – megmondjuk, mi hiányzik és mit lehet tenni -->
    <div class="valaszto-ures" *ngIf="!betolt && !csempek.length">
      <ion-icon name="apps-outline"></ion-icon>
      <h2>Ehhez az alrendszerhez még nincs menüpontod</h2>
      <p>
        Vagy egyetlen oldalhoz sincs jogosultságod, vagy ehhez az intézményhez nincs felvéve
        menü. Szólj az adminisztrátornak, vagy nézd meg a bal oldali menüt.
      </p>
      <ion-button fill="outline" size="small" (click)="menuNyit()">Menü megnyitása</ion-button>
    </div>

  </div>
</ion-content>
